import React, { FC, FormEvent } from "react";

import { BorderedTitle, Form, FormSubmitButton } from "~/components/atoms";
import { DatePicker } from "~/components/molecules";
import { EmployeeSurveyQuestionDetail } from "~/components/organisms";

import {
  EmployeeConditionSurveyWithQuestionsType,
  FormEmployeeConditionSubmissionAnswerType,
} from "~/domains";

type PropsType = {
  employeeConditionSurvey: EmployeeConditionSurveyWithQuestionsType;
  className?: string;
  answers: FormEmployeeConditionSubmissionAnswerType[];
  isSubmitting: boolean;
  postDate: Date;
  onChangePostDate: (date: Date) => void;
  onChangeAnswer: (value: string | undefined, questionId: string) => void;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
};

export const EmployeeConditionDetail: FC<PropsType> = ({
  employeeConditionSurvey,
  className = "",
  postDate,
  answers,
  isSubmitting,
  onChangePostDate,
  onChangeAnswer,
  handleSubmit,
}: PropsType) => {
  return (
    <div className={className}>
      <BorderedTitle title={employeeConditionSurvey.title} />
      {employeeConditionSurvey.description && (
        <h3 className="mt-6 text-secondary-900 border border-solid border-secondary-400 w-full py-2 px-3 rounded">
          {employeeConditionSurvey.description}
        </h3>
      )}
      <div className="mt-6 text-secondary-900 border border-solid bg-secondary-200 border-secondary-400 w-full py-2 px-3 rounded">
        {employeeConditionSurvey.answerShareOption.name}
      </div>
      <Form onSubmit={handleSubmit}>
        <DatePicker
          selectDate={postDate}
          onChange={onChangePostDate}
          shadow-xl
          parentClassName="mt-6"
        />
        <div className="mt-12 space-y-8 px-4">
          {employeeConditionSurvey.questions
            .sort((a, b) => a.displayOrder - b.displayOrder)
            .map((question) => (
              <EmployeeSurveyQuestionDetail
                key={question.id}
                options={question.options || []}
                answers={answers.map((a) => ({
                  questionId: a.employeeConditionSurveyQuestionId,
                  optionId: a.employeeConditionSurveyQuestionOptionId || "",
                  answer: a.answer,
                }))}
                onChangeAnswer={onChangeAnswer}
                question={question}
                displayImage
              />
            ))}
        </div>
        <FormSubmitButton
          color="primary"
          value="投稿する"
          className="w-full mt-4"
          size="md"
          isReadOnly={isSubmitting}
        />
      </Form>
    </div>
  );
};
